<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-layout>
      <h1>{{ title }}</h1>
      <v-spacer></v-spacer>
      <v-btn class="mr-0 primary" :to="{name: 'AdminOrganizationAdd'}">Добавить</v-btn>
    </v-layout>
    <DataTable :items="list" :headers="headers">
      <tr slot-scope="props">
        <td class="text-xs-center">{{ props.index+1 }}</td>
        <td>{{ props.item.name}}</td>
        <td class="text-xs-center">{{ props.item.groups.length}}</td>
        <td class="justify-center layout px-0">
          <v-btn flat icon :to="{name: 'AdminGroupIndex', query: {orgId: props.item.id.toString()}}">
            <v-icon small>remove_red_eye</v-icon>
          </v-btn>
          <v-btn flat icon :to="{name: 'AdminOrganizationEdit', params: {id: props.item.id.toString()}}">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn flat icon @click="deleteConfirm(props.item)">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </tr>
    </DataTable>
    <pagination :pagination="pagination" @currentPageChanged="initRoute"/>
    <DeleteConfirmDialog :dialog="deleteDialog" @confirm="confirm">
      <p>Название: {{ deleteDialog.item.name }}</p>
    </DeleteConfirmDialog>
    <ErrorDialog :dialog="errorDialog"/>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import DataTable from '@/components/fragments/DataTable'
import OrganizationService from '@/services/OrganizationService'
import DeleteConfirmDialog from '@/components/fragments/DeleteConfirmDialog'
import ErrorDialog from '@/components/fragments/ErrorDialog'
import Pagination from '@/components/fragments/Pagination'

export default {
  components: {ErrorDialog, DeleteConfirmDialog, DataTable, Pagination},
  data: () => ({
    list: [],
    headers: [
      {text: '№', align: 'center', sortable: false, width: 50},
      {text: 'Название', align: 'left', sortable: false},
      {text: 'Кол-во групп', align: 'center', sortable: false, width: 105},
      {text: 'Действия', align: 'center', sortable: false, width: 105}
    ],
    deleteDialog: {
      status: false,
      item: OrganizationService.getDefaultItem()
    },
    errorDialog: {
      status: false,
      errors: [],
      title: 'Ошибка при удалении'
    },
    pagination: {
      currentPage: 1,
      totalPages: 1
    },
    replaceRoute: false,
    forceReload: false,
    organizationService: undefined
  }),
  computed: {
    title () {
      return this.$route ? this.$route.meta.title : ''
    },
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    }
  },
  methods: {
    initRoute () {
      let query = {}
      query.page = this.pagination.currentPage
      if (this.replaceRoute) {
        this.$router.replace({query: query})
      } else {
        this.$router.push({query: query})
      }
    },
    loadList () {
      if (this.forceReload || !this.$store.getters.isLoading) {
        this.organizationService.getList((data) => {
          this.pagination.totalPages = data.totalPages
          if (this.pagination.currentPage > this.pagination.totalPages) {
            this.forceReload = true
            this.replaceRoute = true
            this.pagination.currentPage = this.pagination.totalPages
          } else {
            this.forceReload = false
            this.replaceRoute = false
            this.list = data.list
          }
        }, {page: this.pagination.currentPage})
      }
    },
    deleteConfirm (item) {
      this.deleteDialog.item = item
      this.deleteDialog.status = true
    },
    confirm () {
      this.organizationService.deleteItem(this.deleteDialog.item.id, (data) => {
        if (data.status) {
          this.forceReload = true
          this.loadList()
        } else {
          this.errorDialog.errors = data.errors
          this.errorDialog.status = true
        }
      })
    }
  },
  created () {
    this.pagination.currentPage = this.$route.query.page ? Number.parseInt(this.$route.query.page) : 1
    this.organizationService = new OrganizationService(this.$store)
    this.loadList()
  },
  watch: {
    'deleteDialog.status' (val) {
      if (!val) {
        this.deleteDialog.item = OrganizationService.getDefaultItem()
      }
    },
    'errorDialog.status' (val) {
      if (!val) {
        this.errorDialog.errors = []
      }
    },
    '$route.query': {
      handler () {
        this.loadList()
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admin/organization/Index.vue